import type {Icon} from '@primer/octicons-react'
import type {ReactNode} from 'react'

export type ForYouItemTone = 'success' | 'attention' | 'danger' | 'neutral' | 'done'
export type ForYouItemGlyphSize = 12 | 16 | 24

export type ForYouItemVisual =
  | {kind: 'icon'; icon: Icon; tone: ForYouItemTone; glyphSize: ForYouItemGlyphSize}
  | {kind: 'donut'; completed: number; total: number; tone: ForYouItemTone; accessibleLabel: string}
  | {kind: 'spinner'; tone: 'attention'; animated?: boolean}
  | {kind: 'skeleton'}

export type ForYouItemAction = {
  id: string
  content: ReactNode
}

export type CanonicalForYouItemProps = {
  itemId: string
  visual: ForYouItemVisual
  title: string
  subText?: ReactNode
  actions?: readonly ForYouItemAction[]
  busy?: never
  leadingVisual?: never
  emphasizedLeadingVisual?: never
  itemName?: never
  ariaLabel?: never
  actionSlot?: never
  revealActionOnHover?: never
  fullWidthActionSlotOnNarrow?: never
  description?: never
  children?: never
  defaultOpen?: never
  padding?: never
  variant?: never
  footer?: never
}

type LegacyForYouItemBaseProps = {
  itemId?: never
  visual?: never
  subText?: never
  actions?: never
  leadingVisual: ReactNode
  emphasizedLeadingVisual?: boolean
  itemName: string
  actionSlot?: ReactNode
  revealActionOnHover?: boolean
  fullWidthActionSlotOnNarrow?: boolean
  description?: ReactNode
  children?: ReactNode
  defaultOpen?: boolean
  padding?: 'default' | 'none'
  variant?: 'default' | 'embedded'
  busy?: boolean
  footer?: ReactNode
}

type LegacyForYouItemStringTitleProps = LegacyForYouItemBaseProps & {
  title: string
  ariaLabel?: string
}

type LegacyForYouItemNodeTitleProps = LegacyForYouItemBaseProps & {
  title: ReactNode
  ariaLabel: string
}

export type LegacyForYouItemProps = LegacyForYouItemStringTitleProps | LegacyForYouItemNodeTitleProps

export type ForYouItemProps = CanonicalForYouItemProps | LegacyForYouItemProps

export function isCanonicalForYouItemProps(props: ForYouItemProps): props is CanonicalForYouItemProps {
  return 'itemId' in props || props.visual !== undefined
}
